import { createFileRoute } from '@tanstack/react-router'

import { Footer } from '../components/landing/Footer'
import { Header } from '../components/landing/Header'
import { LifestyleProgramsSection } from '../components/landing/LifestyleProgramsSection'
import { buildOgMeta } from '../utils/og'

const LifestyleProgramsPage = () => {
    return (
        <div className="min-h-screen bg-off-white font-sans text-brand-dark">
            <Header />
            <main>
                <LifestyleProgramsSection />
            </main>
            <Footer />
        </div>
    )
}

export const Route = createFileRoute('/lifestyle-programs')({
    component: LifestyleProgramsPage,
    loader: async ({ context }) => {
        const [, websiteSettings] = await Promise.allSettled([
            context.apiUtils.webContent.getAllPublic.ensureData(),
            context.apiUtils.websiteSettings.getPublic.ensureData(),
        ])
        return {
            websiteSettings: websiteSettings.status === 'fulfilled' ? websiteSettings.value : null,
        }
    },
    head: ({ loaderData }) => ({
        meta: buildOgMeta({
            title: 'Long-Y - Életmód programok',
            url: `${import.meta.env.VITE_WEB_URL || ''}/lifestyle-programs`,
            websiteSettings: loaderData?.websiteSettings,
        }),
    }),
})
